import React from 'react';
import { Fragment } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../stylesheets/app.scss';
import Header from '../components/header';
import MainRouter from '../routes/main';
import Footer from '../components/footer';
import { UserShape, TackNotificationsShape, PeopleNotificationsShape, NavigationShape } from '../shapes';
import PropTypes from 'prop-types';

export default class App extends React.Component {
  static propTypes = {
    user: UserShape,
    tackNotifications: TackNotificationsShape,
    peopleNotifications: PeopleNotificationsShape,
    navigation: NavigationShape,
    onLoginIfAuthToken: PropTypes.func,
    onRetrieveTackNotificationsUnreadCount: PropTypes.func,
    onRetrievePeopleNotificationsUnreadCount: PropTypes.func,
    onSyncUnreadNotificationCountWithMobileApp: PropTypes.func,
    onLogout: PropTypes.func,
    onSetPath: PropTypes.func,
    onProcessMobileAppMessage: PropTypes.func
  }

  componentDidMount() {
    this.props.onLoginIfAuthToken();
    window.addEventListener('message', this.processMobileAppMessage.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.props.onProcessMobileAppMessage);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user.get('loggedIn') && this.props.user.get('loggedIn')) {
      this.props.onRetrieveTackNotificationsUnreadCount();
      this.props.onRetrievePeopleNotificationsUnreadCount();
    }

    if ((this.props.navigation.get('pathname') === this.props.navigation.get('afterTackPathname')) && this.props.navigation.get('afterTackScrollPosition') > 0) {
      window.scrollTo(0, this.props.navigation.get('afterTackScrollPosition'));
    }

    const unreadNotificationCount = this.props.tackNotifications.get('unreadCount') + this.props.peopleNotifications.get('unreadCount');
    // Always update to avoid getting out of sync due to race conditions.
    this.props.onSyncUnreadNotificationCountWithMobileApp(unreadNotificationCount);
  }

  render() {
    return(
      <Fragment>
        <Helmet>
          <title>Yak Tack</title>
          <meta name="description" content="An expansive vocabulary can simplify communication, not make it more complicated as most people might infer. It allows people to say what they mean with greater precision. Yak Tack helps people expand their vocabulary."></meta>
          <meta name="og:description" content="An expansive vocabulary can simplify communication, not make it more complicated as most people might infer. It allows people to say what they mean with greater precision. Yak Tack helps people expand their vocabulary."></meta>
          <meta name="og:image" content="https://yaktack-prod-images.s3.us-west-2.amazonaws.com/yak-head.png"></meta>
          <meta name="og:url" content="https://yaktack.com"></meta>
          <meta name="og:title" content="Yak Tack"></meta>
        </Helmet>
        <BrowserRouter>
          <div className='container-fluid'>
            <Header user={ this.props.user } peopleNotifications={ this.props.peopleNotifications } tackNotifications={ this.props.tackNotifications } onLogout={ this.props.onLogout } navigation={ this.props.navigation }/>
            <div className='row yak-tack-main'>
              <div className='offset-sm-3 col-sm-6'>
                <MainRouter onSetPath={ this.props.onSetPath } />
              </div>
            </div>
          </div>
        </BrowserRouter>
        <Footer />
      </Fragment>
    );
  }

  processMobileAppMessage(messageEvent) {
    this.props.onProcessMobileAppMessage(messageEvent, this.props.user.get('loggedIn'));
  }
}



// WEBPACK FOOTER //
// ./src/components/app.jsx